/* Precision Cutworks theme scripts. Progressive enhancement only: every page
   is fully usable and crawlable without JavaScript. */
(function () {
  'use strict';

  /* Desktop dropdowns (disclosure pattern) ------------------------------- */
  function initDropdowns() {
    var items = document.querySelectorAll('.site-nav [data-dropdown]');
    var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function setOpen(item, open) {
      var toggle = item.querySelector('.site-nav__toggle');
      var panel = item.querySelector('.site-nav__dropdown');
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }

    function closeAll(except) {
      items.forEach(function (item) { if (item !== except) setOpen(item, false); });
    }

    items.forEach(function (item) {
      var toggle = item.querySelector('.site-nav__toggle');
      var timer;
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        closeAll(item);
        setOpen(item, open);
      });
      if (hoverCapable) {
        item.addEventListener('mouseenter', function () { clearTimeout(timer); closeAll(item); setOpen(item, true); });
        item.addEventListener('mouseleave', function () { timer = setTimeout(function () { setOpen(item, false); }, 160); });
      }
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) setOpen(item, false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      items.forEach(function (item) {
        var toggle = item.querySelector('.site-nav__toggle');
        if (toggle.getAttribute('aria-expanded') === 'true') {
          setOpen(item, false);
          if (item.contains(document.activeElement)) toggle.focus();
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.site-nav [data-dropdown]')) closeAll();
    });
  }

  /* Mobile drawer -------------------------------------------------------- */
  function initMobileNav() {
    var drawer = document.querySelector('[data-mobile-nav]');
    var openButton = document.querySelector('[data-menu-open]');
    if (!drawer || !openButton) return;
    var closeButton = drawer.querySelector('[data-menu-close]');
    var panel = drawer.querySelector('.mobile-nav__panel');

    function focusables() {
      return Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled])'),
        function (el) { return el.offsetParent !== null; }
      );
    }

    function open() {
      drawer.hidden = false;
      document.body.classList.add('nav-open');
      openButton.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        closeButton.focus();
      });
    }

    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('nav-open');
      openButton.setAttribute('aria-expanded', 'false');
      setTimeout(function () { drawer.hidden = true; }, 200);
      openButton.focus();
    }

    openButton.addEventListener('click', open);
    closeButton.addEventListener('click', close);
    drawer.addEventListener('click', function (event) { if (event.target === drawer) close(); });
    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      var els = focusables();
      var first = els[0];
      var last = els[els.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    drawer.querySelectorAll('.mobile-nav__toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var sub = document.getElementById(toggle.getAttribute('aria-controls'));
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        sub.hidden = expanded;
      });
    });

    window.matchMedia('(min-width: 1366px)').addEventListener('change', function (mq) {
      if (mq.matches && drawer.classList.contains('is-open')) close();
    });
  }

  /* Sticky mobile quote button: shown after the first screen, hidden while
     the footer or an on-page quote CTA is visible so it never covers it. */
  function initStickyQuote() {
    var bar = document.querySelector('[data-sticky-quote]');
    if (!bar || !('IntersectionObserver' in window)) return;
    document.body.classList.add('has-sticky-quote');
    var blockers = document.querySelectorAll('.site-footer, .cta-band');
    var blocking = new Set();
    var scrolledPast = false;

    function update() {
      bar.classList.toggle('is-visible', scrolledPast && blocking.size === 0);
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) blocking.add(entry.target); else blocking.delete(entry.target);
      });
      update();
    });
    blockers.forEach(function (el) { observer.observe(el); });
    window.addEventListener('scroll', function () {
      var past = window.scrollY > window.innerHeight * 0.6;
      if (past !== scrolledPast) { scrolledPast = past; update(); }
    }, { passive: true });
  }

  /* Project gallery filters ---------------------------------------------- */
  function initGalleryFilters() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var buttons = gallery.querySelectorAll('[data-filter]');
      var items = gallery.querySelectorAll('[data-category]');
      var status = gallery.querySelector('[data-filter-status]');
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var value = button.getAttribute('data-filter');
          var shown = 0;
          buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === button ? 'true' : 'false'); });
          items.forEach(function (item) {
            var match = value === 'all' || item.getAttribute('data-category') === value;
            item.hidden = !match;
            if (match) shown += 1;
          });
          if (status) status.textContent = shown + (shown === 1 ? ' project shown' : ' projects shown');
        });
      });
    });
  }

  /* Autoplaying hero video: respect reduced motion and offer a pause button. */
  function initVideos() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.hero__media video').forEach(function (video) {
      var toggle = video.closest('.media-frame').querySelector('[data-video-toggle]');
      function sync() {
        if (!toggle) return;
        toggle.textContent = video.paused ? 'Play video' : 'Pause video';
        toggle.setAttribute('aria-pressed', video.paused ? 'true' : 'false');
      }
      if (reduce) { video.removeAttribute('autoplay'); video.pause(); }
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      if (toggle) toggle.addEventListener('click', function () { if (video.paused) video.play(); else video.pause(); });
      sync();
    });
  }

  /* Quote confirmation page: show the reference returned by the quote service. */
  function initQuoteReference() {
    var el = document.querySelector('[data-quote-reference]');
    if (!el) return;
    var ref = new URLSearchParams(window.location.search).get('ref');
    if (ref && /^[A-Z0-9-]{4,40}$/.test(ref)) {
      el.querySelector('[data-quote-reference-value]').textContent = ref;
      el.hidden = false;
    }
  }

  /* "Cookie preferences" link, shown when Shopify's cookie banner is enabled. */
  function initCookiePreferences() {
    var item = document.querySelector('[data-cookie-preferences]');
    if (!item) return;
    function check() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        item.hidden = false;
        return true;
      }
      return false;
    }
    item.querySelector('button').addEventListener('click', function () { window.privacyBanner.showPreferences(); });
    if (!check()) window.addEventListener('load', function () { setTimeout(check, 1500); });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initDropdowns();
    initMobileNav();
    initStickyQuote();
    initGalleryFilters();
    initVideos();
    initQuoteReference();
    initCookiePreferences();
  });
})();
